const SKIP_QUEUE_RESTORE_KEY = "yulqo_skip_queue_restore";

const turnDismissKey = (clientId: string): string =>
  `yulqo_turn_dismissed_${clientId}`;

export const skipQueueRestoreOnce = (): void => {
  try {
    sessionStorage.setItem(SKIP_QUEUE_RESTORE_KEY, "1");
  } catch {
    /* private mode */
  }
};

export const consumeSkipQueueRestore = (): boolean => {
  try {
    if (sessionStorage.getItem(SKIP_QUEUE_RESTORE_KEY) !== "1") return false;
    sessionStorage.removeItem(SKIP_QUEUE_RESTORE_KEY);
    return true;
  } catch {
    return false;
  }
};

export const readTurnDismissed = (clientId: string): boolean => {
  try {
    return localStorage.getItem(turnDismissKey(clientId)) === "1";
  } catch {
    return false;
  }
};

export const writeTurnDismissed = (clientId: string): void => {
  try {
    localStorage.setItem(turnDismissKey(clientId), "1");
  } catch {
    /* private mode */
  }
};

export const clearTurnDismissed = (clientId: string): void => {
  try {
    localStorage.removeItem(turnDismissKey(clientId));
  } catch {
    /* private mode */
  }
};
